import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  const change = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
  };

  return (
    <div
      className="inline-flex items-center gap-0 rounded-full border border-slate-200 bg-white p-0.5 text-xs font-semibold"
      role="group"
      aria-label="Language switcher"
      data-testid="language-toggle"
    >
      <Globe className="h-3.5 w-3.5 text-slate-400 ml-2 mr-1" aria-hidden />
      <button
        onClick={() => change("fr")}
        className={`px-2.5 py-1 rounded-full transition ${
          current === "fr" ? "bg-brand-green text-white" : "text-slate-600 hover:text-brand-green"
        }`}
        aria-pressed={current === "fr"}
        data-testid="lang-fr-button"
      >
        FR
      </button>
      <button
        onClick={() => change("en")}
        className={`px-2.5 py-1 rounded-full transition ${
          current === "en" ? "bg-brand-blue text-white" : "text-slate-600 hover:text-brand-blue"
        }`}
        aria-pressed={current === "en"}
        data-testid="lang-en-button"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
